"use strict";
/// <reference path="../../../Trillium.UI/TypeScript/Models/Website/MyCommitteesViewModel.tsx"/>
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var CloudDownload_1 = __importDefault(require("@material-ui/icons/CloudDownload"));
function MyCommittees(props) {
    var _a = react_1.default.useState(false), checked = _a[0], setChecked = _a[1];
    var _b = react_1.default.useState(props.Rows), items = _b[0], setItems = _b[1];
    var _c = react_1.default.useState(props.Rows), search = _c[0], setSearch = _c[1];
    var _d = react_1.default.useState([]), selected = _d[0], setSelected = _d[1];
    var _e = react_1.default.useState('asc'), order = _e[0], setOrder = _e[1];
    var _f = react_1.default.useState('Name'), orderBy = _f[0], setOrderBy = _f[1];
    var _onItemInvoked = function (event, item) {
        //@ts-ignore
        onBegin();
        var xhr = new XMLHttpRequest();
        var data = new FormData();
        data.append("ItemUrl", item.Url);
        if (item.FileType === "folder") {
            xhr.open('post', props.GetFolderWithRelatedItemsActionUrl, true);
            xhr.onload = function () {
                var items = JSON.parse(xhr.responseText);
                setItems(items);
                setSearch(items);
                setSelected([]);
                //@ts-ignore
                onComplete();
            };
        }
        else {
            xhr.responseType = 'blob';
            xhr.open('post', props.DownloadFileActionUrl, true);
            xhr.onload = function () {
                var blob = new Blob([xhr.response]);
                var contentDisposition = xhr.getResponseHeader('Content-Disposition');
                var fileName = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1];
                var url = window.URL.createObjectURL(new Blob([blob]));
                ;
                var link = document.createElement('a');
                link.href = url;
                link.download = fileName.replace(/['"]/g, '');
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                //@ts-ignore
                onComplete();
            };
        }
        xhr.send(data);
    };
    var _onItemSelected = function (event, item) {
        var selectedIndex = selected.indexOf(item);
        var newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, item);
        }
        else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        }
        else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        }
        else if (selectedIndex > 0) {
            newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        }
        setSelected(newSelected);
    };
    var _onItemCompare = function (itemA, itemB, filedName) {
        if (itemA[filedName] < itemB[filedName])
            return -1;
        if (itemA[filedName] > itemB[filedName])
            return 1;
        return 0;
    };
    var _onItemSortRequest = function (event, columnId) {
        var property = columnId;
        var isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };
    var _isSelected = function (item) { return selected.indexOf(item) !== -1; };
    var _onItemSelectAll = function (event) {
        if (event.target.checked)
            setSelected(items);
        else
            setSelected([]);
        setChecked(event.target.checked);
    };
    var _onItemDownload = function (event) {
        //@ts-ignore
        onBegin();
        var folderUrls = new Array();
        var fileUrls = new Array();
        for (var _i = 0, selected_1 = selected; _i < selected_1.length; _i++) {
            var item = selected_1[_i];
            if (item.FileType !== "folder") {
                fileUrls.push(item.Url);
            }
        }
        var data = new FormData();
        data.append("folderUrls", JSON.stringify(folderUrls));
        data.append("fileUrls", JSON.stringify(fileUrls));
        var xhr = new XMLHttpRequest();
        xhr.open('post', props.DownloadZipActionUrl, true);
        xhr.responseType = 'blob';
        xhr.onload = function () {
            var blob = new Blob([xhr.response]);
            var contentDisposition = xhr.getResponseHeader('Content-Disposition');
            var fileName = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1];
            var url = window.URL.createObjectURL(new Blob([blob]));
            ;
            var link = document.createElement('a');
            link.href = url;
            link.download = fileName.replace(/['"]/g, '');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            //@ts-ignore
            onComplete();
        };
        xhr.send(data);
    };
    var _onSearchInputChange = function (event) {
        if (search === null || search === undefined || search.length === 0) {
            setSearch(items);
        }
        var filterItems = event.target.value ? items.filter(function (i) { return i.Name.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1; }) : search;
        setItems(filterItems);
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(core_1.TextField, { id: "filled-search", fullWidth: true, label: "Filter by name", type: "search", variant: "filled", onChange: function (event) { return _onSearchInputChange(event); } }),
        react_1.default.createElement("br", null),
        react_1.default.createElement("br", null),
        react_1.default.createElement(core_1.Paper, null,
            react_1.default.createElement(core_1.TableContainer, null,
                react_1.default.createElement(core_1.Table, null,
                    react_1.default.createElement(core_1.TableHead, null,
                        react_1.default.createElement(core_1.TableRow, null,
                            react_1.default.createElement(core_1.TableCell, { padding: "checkbox" },
                                react_1.default.createElement(core_1.Checkbox, { key: "_onItemSelectAll_Checkbox", indeterminate: selected.length > 0 && selected.length < items.length, checked: items.length > 0 && selected.length === items.length, onChange: function (event) { return _onItemSelectAll(event); } })),
                            props.Columns.map(function (column) { return (react_1.default.createElement(core_1.TableCell, { component: "th", key: column.Id, id: column.Id, scope: "cell" },
                                react_1.default.createElement(core_1.TableSortLabel, { active: orderBy === column.Id, direction: orderBy === column.Id ? order : 'asc', onClick: function (event) { return _onItemSortRequest(event, column.Id); } }, column.Label))); }))),
                    react_1.default.createElement(core_1.TableBody, null,
                        items.sort(function (a, b) {
                            return order === 'desc' ? _onItemCompare(a, b, orderBy) : -_onItemCompare(a, b, orderBy);
                        }).map(function (row) {
                            var isItemSelected = _isSelected(row);
                            return (react_1.default.createElement(core_1.TableRow, { hover: true, role: "checkbox", tabIndex: -1, key: "TableRow" + row.Id },
                                react_1.default.createElement(core_1.TableCell, { padding: "checkbox" },
                                    react_1.default.createElement(core_1.Checkbox, { key: "Checkbox" + row.Id, checked: isItemSelected, onClick: function (event) { return _onItemSelected(event, row); } })),
                                react_1.default.createElement(core_1.TableCell, { component: "th", id: "FileIcon" + row.Id, scope: "row", padding: "none" },
                                    react_1.default.createElement("img", { key: "icon" + row.Id, src: row.FileIcon, width: 24, height: 24 })),
                                react_1.default.createElement(core_1.TableCell, { align: "left" },
                                    react_1.default.createElement(core_1.Link, { key: "link" + row.Id, onClick: function (event) { return _onItemInvoked(event, row); } }, row.Name)),
                                react_1.default.createElement(core_1.TableCell, { align: "left" }, row.ModifiedValue),
                                react_1.default.createElement(core_1.TableCell, { align: "right" }, row.FileSize)));
                        }),
                        react_1.default.createElement(core_1.TableRow, null,
                            react_1.default.createElement(core_1.TableCell, { colSpan: 6 },
                                selected.length !== 0 ? react_1.default.createElement(core_1.Button, { variant: "contained", color: "default", startIcon: react_1.default.createElement(CloudDownload_1.default, null), onClick: function (event) { return _onItemDownload(event); } }, "Download") : undefined,
                                items.length === 0 ? react_1.default.createElement("div", null, "No items to display") : undefined))))))));
}
exports.default = MyCommittees;
